export default __webpack_public_path__ + "static/cash-fb8c2a3923a8951b48aba883fa5a0ef7.webp";